import React, { useState, useEffect } from 'react';
import { MDBCard, MDBCardBody } from 'mdb-react-ui-kit';

const RecentActivity = () => {
  const [activities, setActivities] = useState([]);
  const [visibleCount, setVisibleCount] = useState(0);

  const allActivities = [
    {
      id: 1,
      icon: '🚀',
      title: 'Product uploaded to eBay & Shopify',
      description: 'Vintage Leather Jacket - Size M',
      time: '2 minutes ago',
      status: 'success'
    },
    {
      id: 2,
      icon: '✨',
      title: 'Image enhanced successfully',
      description: 'Background removed, quality improved',
      time: '5 minutes ago',
      status: 'success'
    },
    {
      id: 3,
      icon: '🏪',
      title: 'Listing deployed to 5 marketplaces',
      description: 'Nike Air Jordan 1 - Limited Edition',
      time: '12 minutes ago',
      status: 'success'
    },
    {
      id: 4,
      icon: '🔍',
      title: 'Blurred image detected',
      description: 'Manual review recommended',
      time: '18 minutes ago',
      status: 'warning'
    },
    {
      id: 5,
      icon: '💰',
      title: 'Product sold on Poshmark',
      description: 'Gucci Belt - Authentic',
      time: '25 minutes ago',
      status: 'success'
    },
    {
      id: 6,
      icon: '🔄',
      title: 'Inventory sync completed',
      description: 'All platforms updated',
      time: '32 minutes ago',
      status: 'info'
    },
    {
      id: 7,
      icon: '📊',
      title: 'Weekly report generated',
      description: '156 products processed',
      time: '1 hour ago',
      status: 'info'
    }
  ];

  useEffect(() => {
    setActivities(allActivities);
    
    // Animate activities appearing
    const timer = setInterval(() => {
      setVisibleCount(prev => {
        if (prev < allActivities.length) {
          return prev + 1;
        }
        clearInterval(timer);
        return prev;
      });
    }, 200);
    
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MDBCard className="dashboard-card activity-panel-card">
      <MDBCardBody>
        <div className="card-header">
          <h3 className="card-title">Recent Activity</h3>
          <p className="card-subtitle">Latest system events</p>
        </div>
        
        <div className="activity-timeline">
          {activities.slice(0, visibleCount).map((activity, index) => (
            <div 
              key={activity.id}
              className={`activity-item ${activity.status}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="activity-icon">{activity.icon}</div>
              <div className="activity-content">
                <div className="activity-title">{activity.title}</div>
                <div className="activity-description">{activity.description}</div>
                <div className="activity-time">{activity.time}</div>
              </div>
              <div className={`activity-status ${activity.status}`}></div>
            </div>
          ))}
        </div>
        
        <div className="activity-footer">
          <button className="view-all-btn">
            View All Activity
            <span className="btn-arrow">→</span>
          </button>
        </div>
      </MDBCardBody>
    </MDBCard>
  );
};

export default RecentActivity;